import type { IconProps } from "@circle-react-shared/Icon";

export const variants = {
  sm: "sm",
  md: "md",
  lg: "lg",
  xl: "xl",
} as const;
export type Variant = keyof typeof variants;

export type VariantProps = Partial<Omit<IconProps, "type">>;
